import {createStore} from 'vuex'
import router from "@/router";

export default createStore({
	state: {
		ImageUrl: "http://120.78.92.171:8080/Image",
		prefix: '',
		width: document.body.clientWidth,
		barUrlList: [],
		bar: "主页",
		navigationBar: [
			{
				title: "主页",
				url: "/"
			},
			{
				title: "走进铱加",
				url: "/aboutUs",
				bar: [{
					name: '公司简介',
					url: "/aboutUs",
				}, {
					name: '公司荣誉',
					url: "/ListHonor",
				}, {
					name: '公司文化',
					url: "/Culture",
				}]
			},
			{
				title: "产品中心",
				url: "/Products",
				bar: [
					{
						"name": "光芯片",
						"title": 1,
						"url": "/Products?Type=1",
						"list": [
							{
								"name": "50G速率",
								"url": "/Products?Type=1&working=13"
							}
						]
					},
					{
						"name": "光引擎",
						"title": 2,
						"url": "/Products?Type=2",
						"list": [
							{
								"name": "10G速率",
								"url": "/Products?Type=2&working=9"
							},
							{
								"name": "25G速率",
								"url": "/Products?Type=2&working=10"
							},
							{
								"name": "100G速率",
								"url": "/Products?Type=2&working=11"
							},
							{
								"name": "400G速率",
								"url": "/Products?Type=2&working=12"
							}
						]
					},
					{
						"name": "光模块",
						"title": 3,
						"url": "/Products?Type=3",
						"list": [
							{
								"name": "DCN&DCI",
								"url": "/Products?Type=3&type=1"
							},
							{
								"name": "Telecom IP",
								"url": "/Products?Type=3&type=3"
							},
							{
								"name": "Wireless Access",
								"url": "/Products?Type=3&type=2"
							}
						]
					}
				]
			},
			{
				title: "公司动态",
				url: "/JoinUs",
				bar: [{
					name: '人才理念',
					url: "/JoinUs",
				}, {
					name: '工作岗位',
					url: "/SocialInde",
				}, {
					name: '联系方式',
					url: "/ContactUs",
				}]
			},
		],
	},
	getters: {},
	mutations: {
		setWidth(state, res) {
			state.width = res
		},
		setNavigationBar(state, res) {
			state.navigationBar[2].bar = res
		},
		gotoUrl(state, res) {
			if (sessionStorage.barTitleUrl == res.barTitleUrl) {
				router.push(state.prefix + res.url).then(r => {
					window.scrollTo(0, 0);
				})
			} else {
				router.push(state.prefix + res.url).then(r => {
					window.scrollTo(0, 0);
				})
			}
			sessionStorage.bar = res.bar
			sessionStorage.barUrl = res.url
			sessionStorage.barTitleUrl = res.barTitleUrl
			state.bar = res.barTitleUrl
		},

		getBarList(state, res) {
			state.bar = sessionStorage.barTitleUrl
			for (let item of state.navigationBar) {
				if (item.url == sessionStorage.barTitleUrl) {
					state.barUrlList = item.bar;
				}
			}
		}
	},
	actions: {},
	modules: {}
})
